import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLiquidFilterFixedBed = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 50,
	height: 100,
	viewBox: "0 0 50.0 100.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 0,
			width: 50,
			height: 100,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 0.0 20.0 L 50.0 80.0 M 50.0 20.0 L 0.0 80.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 0.0 20.0 L 50.0 20.0 M 0.0 80.0 L 50.0 80.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1,
			strokeDasharray: "2 2"
		})
	]
});
export default SvgLiquidFilterFixedBed;
